import { log } from "console"

export class WhatsappLogDto{
    logId:number
    contactNo:string
    templateName:string
    createdUser:string
    projectName:string
    generetedAt:any
    
    constructor(
        logId:number,

        contactNo:string,
    
        templateName:string,
    
        createdUser:string,
    
        projectName:string,
    
        generetedAt:any,
    ){
        this.logId=logId;
        this.contactNo=contactNo;
        this.templateName=templateName;
        this.createdUser=createdUser;
        this.projectName=projectName;
        this.generetedAt=generetedAt;
    }


}
export class whatsappsLogDto{

    contactNo:string
    templateName:string
    projectName:string
    companyId:number;   
    moduleId:number;
    constructor(
        contactNo:string,
        templateName:string,
        projectName:string,
        companyId:number,  
        moduleId:number
    ){
        this.contactNo=contactNo;
        this.templateName=templateName;
        this.projectName=projectName;
        this.companyId=companyId;
        this.moduleId=moduleId;
    }
}
